import React from 'react'

export const icon_homepage_hover = () => (
    <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>icon_homepage_hover</title>
        <g id="网页展示" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="边上按钮hover" transform="translate(-1856.000000, -880.000000)">
                <g id="编组-3" transform="translate(1856.000000, 880.000000)">
                    <rect id="矩形" x="0" y="0" width="32" height="32"></rect>
                    <g
                        id="编组-4"
                        transform="translate(5.000000, 6.000000)"
                        stroke="#455F8F"
                        strokeWidth="2"
                    >
                        <path
                            d="M10.9999753,1.00538827 L20.9949483,8.83816349 L18.0665846,8.86691562 L17.9566088,18.9846797 L4.04617697,19 L4.04235013,9.01453973 L1.04317588,8.86863119 L10.9999753,1.00538827 Z"
                            id="路径"
                        ></path>
                        <path
                            d="M9.01080771,18.97349 L9.01080771,14.9204699 C9.01080771,13.8012594 9.90138835,12.8939599 10.9999753,12.8939599 C12.0985622,12.8939599 12.9891428,13.8012594 12.9891428,14.9204699 L12.9891428,18.97349"
                            id="路径"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
export const icon_detail_hover = () => (
    <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>icon_detail_hover</title>
        <g id="网页展示" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="边上按钮hover" transform="translate(-1856.000000, -929.000000)">
                <g id="编组-3备份" transform="translate(1856.000000, 929.000000)">
                    <rect id="矩形" x="0" y="0" width="32" height="32"></rect>
                    <path
                        d="M21,8 C21.8284271,8 22.5784271,8.33578644 23.1213203,8.87867966 C23.6642136,9.42157288 24,10.1715729 24,11 L24,11 L24,20 C24,21.3807119 23.4403559,22.6307119 22.5355339,23.5355339 C21.6307119,24.4403559 20.3807119,25 19,25 L19,25 L11,25 C10.1715729,25 9.42157288,24.6642136 8.87867966,24.1213203 C8.33578644,23.5784271 8,22.8284271 8,22 L8,22 L8,11 C8,10.1715729 8.33578644,9.42157288 8.87867966,8.87867966 C9.42157288,8.33578644 10.1715729,8 11,8 L11,8 Z"
                        id="矩形"
                        stroke="#455F8F"
                        strokeWidth="2"
                    ></path>
                    <rect id="矩形" fill="#455F8F" x="11" y="13" width="7" height="2" rx="1"></rect>
                    <rect
                        id="矩形备份"
                        fill="#455F8F"
                        x="11"
                        y="17"
                        width="5"
                        height="2"
                        rx="1"
                    ></rect>
                </g>
            </g>
        </g>
    </svg>
)
export const icon_big_hover = () => (
    <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>icon_big_hover</title>
        <g id="网页展示" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="边上按钮hover" transform="translate(-1856.000000, -978.000000)">
                <g id="编组-3备份-2" transform="translate(1856.000000, 978.000000)">
                    <rect id="矩形" x="0" y="0" width="32" height="32"></rect>
                    <g
                        id="编组-5"
                        transform="translate(6.500000, 6.500000)"
                        stroke="#455F8F"
                        strokeLinecap="round"
                        strokeWidth="2"
                    >
                        <g
                            id="编组"
                            transform="translate(14.620839, 4.620839) rotate(-315.000000) translate(-14.620839, -4.620839) translate(11.378199, 1.328626)"
                        >
                            <path
                                d="M-1.10503689e-12,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                        <g
                            id="编组备份"
                            transform="translate(14.620839, 14.620839) scale(1, -1) rotate(-315.000000) translate(-14.620839, -14.620839) translate(11.378199, 11.328626)"
                        >
                            <path
                                d="M-8.49662241e-13,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                        <g
                            id="编组备份-2"
                            transform="translate(4.620839, 14.620839) scale(-1, -1) rotate(-315.000000) translate(-4.620839, -14.620839) translate(1.378199, 11.328626)"
                        >
                            <path
                                d="M1.44074503e-12,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                        <g
                            id="编组备份-3"
                            transform="translate(4.620839, 4.620839) scale(-1, 1) rotate(-315.000000) translate(-4.620839, -4.620839) translate(1.378199, 1.328626)"
                        >
                            <path
                                d="M-6.45011994e-13,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
export const icon_small = () => (
    <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>icon_small</title>
        <g id="网页展示" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="全屏" transform="translate(-1864.000000, -24.000000)">
                <g id="编组-3备份-2" transform="translate(1864.000000, 24.000000)">
                    <rect
                        id="矩形"
                        fill="#FFFFFF"
                        opacity="0.197614397"
                        x="0"
                        y="0"
                        width="32"
                        height="32"
                        rx="8"
                    ></rect>
                    <g
                        id="编组-5"
                        transform="translate(6.500000, 6.500000)"
                        stroke="#EEEEEE"
                        stroke-linecap="round"
                        stroke-width="2"
                    >
                        <g
                            id="编组"
                            transform="translate(14.620839, 4.620839) scale(-1, -1) rotate(-315.000000) translate(-14.620839, -4.620839) translate(11.378199, 1.328626)"
                        >
                            <path
                                d="M-8.95015719e-13,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                        <g
                            id="编组备份"
                            transform="translate(14.620839, 14.620839) scale(-1, 1) rotate(-315.000000) translate(-14.620839, -14.620839) translate(11.378199, 11.328626)"
                        >
                            <path
                                d="M-1.33451903e-13,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                        <g
                            id="编组备份-2"
                            transform="translate(4.620839, 14.620839) rotate(-315.000000) translate(-4.620839, -14.620839) translate(1.378199, 11.328626)"
                        >
                            <path
                                d="M9.6350358e-13,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                        <g
                            id="编组备份-3"
                            transform="translate(4.620839, 4.620839) scale(1, -1) rotate(-315.000000) translate(-4.620839, -4.620839) translate(1.378199, 1.328626)"
                        >
                            <path
                                d="M1.42594494e-12,2.85650364 L2.5791539,0.277349739 C2.94558754,-0.0890838927 3.53586504,-0.0929126886 3.89757562,0.268797884 L6.48528137,2.85650364"
                                id="形状"
                            ></path>
                            <line
                                x1="3.24264069"
                                y1="0.613862956"
                                x2="3.24264069"
                                y2="6.5844257"
                                id="路径-3"
                            ></line>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
